import { useOnChangeV2 } from '../../../../../../logic/useOnChangeV2'
import { useAppSelector } from '../../../../../../../app/hooks'
import { InitState } from '../../../../../../../redux/reducers/root/initialState'
import {
  ContentStateInterface,
  isEditEntryMode,
  OnChangeValue,
  ScreenProperty,
} from '../../../../../../../@types/types'
import { useCallback } from 'react'
import { formatNumberForDisplay } from '../../../../../../../i18next/decimal'

export function useOnPriceChange() {
  const onChangeV2 = useOnChangeV2()
  const entryMode = useAppSelector(
    (state: InitState) => state.insertionFeature.insertionIdentification.metaInformation?.entryMode
  )
  const flowInformation = useAppSelector((state: InitState) => state.flowFeature.flowInformation)
  const formState = useAppSelector((state: InitState) => state.formStateFeature)
  const depositCalculationEnabled =
    !isEditEntryMode(entryMode) &&
    flowInformation.options?.depositCalculationEnabled === true &&
    !formState?.touched['deposit']

  return useCallback(
    (screenProperty: ScreenProperty, value: OnChangeValue) => {
      onChangeV2((old): ContentStateInterface => {
        const updateDeposit = !depositCalculationEnabled || !value
        const nextPrice =
          typeof value === 'number' ? value : typeof value === 'string' && value !== '' ? Number(value) : undefined
        const shouldHideRecommendedPrefilledHint =
          old.isRecommendedPricePrefilledVisible === true &&
          (old.recommendedPrefilledPrice === undefined || nextPrice !== old.recommendedPrefilledPrice)

        return {
          ...old,
          [screenProperty.property]: value,
          deposit: updateDeposit ? old.deposit : formatNumberForDisplay(Number(value) * 3),
          ...(shouldHideRecommendedPrefilledHint && { isRecommendedPricePrefilledVisible: false }),
        }
      })
    },
    [depositCalculationEnabled, onChangeV2]
  )
}
